import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  & > * {
    margin-bottom: 20px;
  }
  @media (min-width: 426px) {
  }
`;

export const Form = styled.form`
  width: 100%;
  & > * {
    margin-bottom: 10px;
  }
  @media (min-width: 426px) {
  }
`;

export const RestaurantImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  flex-direction: column;
  & > div:first-child {
    margin-bottom: 10px;
  }
  @media (min-width: 426px) {
    flex-direction: row;
  }
  & p {
    font-size: 15px;
    text-align: center;
  }
  & .dropzone {
    width: 100%;
    height: auto;
    @media (min-width: 426px) {
      width: 300px;
      height: 200px;
    }
  }
`;
